// extracted by mini-css-extract-plugin
module.exports = {"pc":"layout_pc__1gYel","mobile":"layout_mobile__nIa0_","main":"layout_main__1zm7H"};